import { Runbook, OrderReceipt } from '../types';
import { INITIAL_RUNBOOKS } from '../data/runbooks';

const STORAGE_KEY = 'runbook_bureau_state_v1';

interface AppState {
  catalog: Runbook[];
  unlockedSlugs: string[];
  unlockedTools: string[];
  orders: OrderReceipt[];
  leads: string[];
  stripePaymentLink: string;
}

export function loadStoredState(): AppState {
  const defaultState: AppState = {
    catalog: [...INITIAL_RUNBOOKS],
    unlockedSlugs: [],
    unlockedTools: [],
    orders: [],
    leads: [],
    stripePaymentLink: '',
  };

  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaultState;
    const parsed = JSON.parse(raw);
    return {
      catalog: parsed.catalog || defaultState.catalog,
      unlockedSlugs: parsed.unlockedSlugs || [],
      unlockedTools: parsed.unlockedTools || [],
      orders: parsed.orders || [],
      leads: parsed.leads || [],
      stripePaymentLink: parsed.stripePaymentLink || '',
    };
  } catch (e) {
    console.error("Failed to load local storage state:", e);
    return defaultState;
  }
}

export function saveStoredState(state: AppState): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (e) {
    console.error("Failed to save local storage state:", e);
  }
}
